module.exports = __webpack_public_path__ + "images/psp/PSPVideo/motorcycle-winterizing-steps.png";